module.exports = __webpack_public_path__ + "static/forecast/elevation-mountains-6d8d5d7b5f8a3d944f7dbf4467798faf.png";